import { useNavigate } from 'react-router-dom';
import { AttendeeLayout as BaseAttendeeLayout } from '@festpix/ui';
import { auth } from '@festpix/services';

interface AttendeeLayoutProps {
  children: React.ReactNode;
  showBackButton?: boolean;
}

export default function AttendeeLayout({ children, showBackButton = false }: AttendeeLayoutProps) {
  const navigate = useNavigate();

  const handleSignOut = () => {
    auth.signOut();
    navigate('/login');
  };

  return (
    <BaseAttendeeLayout
      showBackButton={showBackButton}
      onSignOut={handleSignOut}
      homeRoute="/"
    >
      {children}
    </BaseAttendeeLayout>
  );
}
